import axios from 'axios';

// Use relative path in production, localhost in development
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api'
  : 'http://localhost:5000/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const userId = localStorage.getItem('userId');
  if (userId) {
    config.headers.Authorization = `Bearer ${userId}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('userId');
      localStorage.removeItem('username');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    return response.data;
  },
};

// Tasks API
export const tasksAPI = {
  getTasks: async () => {
    const response = await api.get('/tasks');
    return response.data;
  },
  
  getTaskDetails: async (taskId) => {
    const response = await api.get(`/tasks/${taskId}/details`);
    return response.data;
  },
  
  startScraping: async (url) => {
    const response = await api.post('/scrape', { url });
    return response.data;
  },
  
  startTranslation: async (scrapeTaskId, targetLanguage) => {
    const response = await api.post('/translate', {
      scrape_task_id: scrapeTaskId,
      target_language: targetLanguage,
    });
    return response.data;
  },
  
  cancelTask: async (taskId) => {
    const response = await api.post(`/tasks/${taskId}/cancel`);
    return response.data;
  },
  
  downloadTask: async (taskId) => {
    try {
      const response = await api.get(`/tasks/${taskId}/download`, {
        responseType: 'blob'
      });
      
      // Create a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `translation_${taskId}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      throw error;
    }
  },
};

// File API
export const filesAPI = {
  getFileUrl: (filepath) => {
    const userId = localStorage.getItem('userId');
    // URL encode the auth parameter to handle the space in "Bearer 1"
    const authParam = encodeURIComponent(`Bearer ${userId}`);
    return `${API_BASE_URL}/files/${filepath}?auth=${authParam}`;
  },
};

// Batch API
export const batchAPI = {
  createBatchJob: async (urls, languages, name) => {
    const response = await api.post('/batch', {
      urls,
      languages,
      name
    });
    return response.data;
  },
  
  getBatchJob: async (batchJobId) => {
    const response = await api.get(`/batch/${batchJobId}`);
    return response.data;
  },
  
  listBatchJobs: async () => {
    const response = await api.get('/batch/list');
    return response.data;
  },
};

export default api; 